import { CmsConfigs } from '../models/configs.model';

const { REACT_APP_STH_SITE_HOSTNAME } = process.env;
const clubConfig: Map<string, CmsConfigs> = new Map<string, CmsConfigs>();
clubConfig.set(
  'chc', {
  teamName: 'cubs',
  venueName: 'Wrigley Field',
  venueId: '17',
  clubCode: 'chc',
  homepath: '/tickets/season-tickets/waiting-list',
  features: ['waitingList']
});
clubConfig.set(
  'min', {
  teamName: 'twins',
  venueName: 'Target Field',
  venueId: '3312',
  clubCode: 'min',
  homepath: '/tickets/season-tickets/my-twins-account',
  features: ['partner']
});

export const getHomepath: (config: CmsConfigs | undefined) => string = (config: CmsConfigs | undefined): string => {
  if (window.location.host === 'localhost:3000')
    return "";
  else
    return config === undefined ? "" : `${REACT_APP_STH_SITE_HOSTNAME}/${config.teamName}${config.homepath}`;
}

export const getLogoutUrl = (config: CmsConfigs | undefined) => {
  return `${REACT_APP_STH_SITE_HOSTNAME}/logout?redirectUri=${getHomepath(config)}`;
}

export const getConfigs: (configKey: string | null) => CmsConfigs =
  (configKey: string | null): CmsConfigs => {

    const defaultConfig: CmsConfigs = {
      teamName: 'cubs',
      venueName: 'Wrigley Field',
      venueId: '17',
      clubCode: 'chc',
      homepath: '/tickets/season-tickets/waiting-list',
      features: ['waitingList']
    };

    if (!configKey) {
      return defaultConfig;
    }

    const retConfig: CmsConfigs | undefined = clubConfig.get(configKey);
    if (retConfig) {
      return retConfig;
    } else {
      return defaultConfig;
    }
  };
